import React from 'react';
import { Box, Flex, HStack, Icon, Text } from '@spothero/ui';
import IconPriceTag from '@spothero/icons/price-tag';
export function AllInPricingCallout() {
    return (<Flex data-testid="AllInPricingCallout" flexGrow={{ base: 0, mobileXL: 1 }} justifyContent={{ base: 'center', mobileXL: 'flex-end' }}>
            <Flex align="center" borderRadius="md" paddingTop={{ base: 1, mobileXL: 3 }} paddingBottom={3}>
                <HStack spacing={2} align="center">
                    <Box color="#1271EB">
                        <Icon as={IconPriceTag} boxSize={4} marginTop={2}/>
                    </Box>

                    <Box position="relative" minWidth="max-content">
                        <Text fontSize={{ base: 'xs', mobileXL: 'sm' }} fontWeight="normal" whiteSpace="nowrap" color="black">
                            No surprises! Fees are included in the total price.
                        </Text>
                    </Box>
                </HStack>
            </Flex>
        </Flex>);
}
